export const ADD_SETTING = "ADD_SETTING";
